// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CreateImage } from '../../icons/status';
import { useAppStyles } from '../../styles';
import { TrackedButton } from '../common';

// Curriculum list empty state properties.
export type EmptyStateProps = Readonly<{
    onCreate: () => void;
    onLink: () => void;
}>;

// Curriculum list empty state.
export default (props: EmptyStateProps) => {
    const { onCreate, onLink } = props;
    const styles = useAppStyles();

    return (
        <div className={styles.emptyState}>
            <CreateImage className={styles.emptyStateImage} />
            <FormattedMessage
                description="Empty activity list message"
                defaultMessage="It's lonely in here... create an activity to get started."
            />
            <div className={styles.flexRowSmallGapCentered}>
                <TrackedButton
                    trackAction="new-activity"
                    className={mergeClasses(styles.button, styles.buttonPrimary)}
                    onClick={onCreate}
                >
                    <FormattedMessage
                        description="Empty activity list new activity button"
                        defaultMessage="Create new"
                    />
                </TrackedButton>
                <FormattedMessage description="Empty activity list or" defaultMessage="or" />
                <TrackedButton trackAction="link-existing" className={styles.button} onClick={onLink}>
                    <FormattedMessage
                        description="Link existing repo button title"
                        defaultMessage="Link existing repo"
                    />
                </TrackedButton>
            </div>
        </div>
    );
};
